module.exports = __webpack_public_path__ + "static/media/Pantheon_0.64afe29e.png";